import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import type {
  NotificationAssignment,
  NotificationAssignmentFormValues,
} from "../models/notificationAssignment"
import { notificationAssignmentApi } from "../services/notificationAssignmentApi"

const BASE_KEY = "notification-assignments"

export function useRoles() {
  return useQuery<{ name: string; description: string }[]>({
    queryKey: [BASE_KEY, "roles"],
    queryFn: async () => {
      const data = await notificationAssignmentApi.getRoles()
      return Array.isArray(data) ? data : []
    },
    staleTime: 1000 * 60 * 30,
  })
}

export function useCreateNotificationAssignment() {
  const queryClient = useQueryClient()
  return useMutation<
    NotificationAssignment,
    Error,
    NotificationAssignmentFormValues
  >({
    mutationFn: (values) =>
      notificationAssignmentApi.create(
        values,
      ) as Promise<NotificationAssignment>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useDeleteNotificationAssignment() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, { role: string; notificationKey: string }>({
    mutationFn: ({ role, notificationKey }) =>
      notificationAssignmentApi.delete(role, notificationKey) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}
